import { useEffect } from "react";
import Zendesk from "react-zendesk";
const ZENDESK_KEY = "951cb0bb-7d80-4240-a22f-c64071e767e8";

const ChatComponent = () => {

    
  //  useEffect(() => {
  //   const script = document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.src = 'https://static.zdassets.com/ekr/snippet.js?key=951cb0bb-7d80-4240-a22f-c64071e767e8';
  //   script.id = 'ze-snippet"';
  //   script.async = true;
  //   document.body.appendChild(script);

  //     return () => {
  //       document.getElementById('ze-snippet')?.remove()
  //     };

  //  }, [])
  
  useEffect(() => {
    
    return () => {}
}, [])
  

return <Zendesk defer zendeskKey={ZENDESK_KEY}  />



}

export default ChatComponent;